import { forwardRef } from 'react';
import { useTable } from 'api';
import { endpoints } from 'endpoints.config';
import './ConnectionsPage.scss';
import { FoldingCube } from 'better-react-spinkit';
import { useTheme } from '@emotion/react';
import { ItemConnection, ItemConnectionModel } from './items/ItemConnection';
import Pagination from 'components/pagination/Pagination';

export const PendingConnectionsRequests = forwardRef<HTMLDivElement>((_, ref) => {
  const { colors } = useTheme();

  const {
    data,
    loading,
    reload,
  } = useTable<ItemConnectionModel, any>({
    url: `${endpoints.networkmodule.getNetworkConnections}?ConnectionStatus=PENDING`,
    bClearFilters: true,
  });

  const listData = data?.details?.listData ?? [];

  return (
    <div className="list-container-networks" ref={ref}>
      {loading && (
        <div className="PageLoader">
          <FoldingCube color={colors.first} size={80} />
        </div>
      )}

      {!loading && listData.length === 0 && (
        <div className="no-results-message">No results found</div>
      )}

      {listData.map((item, index) => (
        <ItemConnection
          key={`${item.receiverId}_${index}`}
          networkUser={item}
          refreshList={reload}
        />
      ))}

      <Pagination table={{ data, loading, reload }} />
    </div>
  );
});
